module.exports = __webpack_public_path__ + "img/12_dice[10].47560ade.png";